export const parseExceptions = text => {
  const parts = String(text).split(/[\n,]/).map(value => value.trim()).filter(Boolean)
  const ips = []
  for (const value of parts) {
    if (/^(0|[1-9]\d{0,2})(\.(0|[1-9]\d{0,2})){3}$/.test(value) && value.split(".").every(byte => Number(byte) <= 255)) ips.push(value)
    else if (value.includes(":")) {
      try {
        if (!/^[a-f\d:.]+$/i.test(value)) throw new Error()
        const ip = new URL(`http://[${value}]/`).hostname.slice(1, -1)
        if (ip.startsWith("::ffff:")) {
          const words = ip.slice(7).split(":").map(part => parseInt(part, 16))
          ips.push([words[0] >> 8, words[0] & 255, words[1] >> 8, words[1] & 255].join("."))
        } else ips.push(ip)
      } catch { return { error: "Enter valid individual IPv4 or IPv6 addresses, without ranges." } }
    } else return { error: "Enter valid individual IPv4 or IPv6 addresses, without ranges." }
  }
  const unique = [...new Set(ips)].sort()
  return unique.length > 100 ? { error: "Use at most 100 IP addresses." } : { ips: unique }
}
export const settingsTime = value => !value || !Number.isFinite(new Date(value).getTime()) ? "Unavailable" : new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Bucharest", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
}).format(new Date(value))
